import React, { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { custDb } from "../../../firebaseCust";

export default function StoreBranding() {

  const [storeCode, setStoreCode] = useState("");
  const [storeName, setStoreName] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");
  const [primaryColor, setPrimaryColor] = useState("#000000");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    if (!storeCode) {
      alert("Enter Store Code first");
      return;
    }

    setSaving(true);

    try {
      const storeRef = doc(custDb, "customers", storeCode, "details", "main");

      await setDoc(storeRef, {
        storeName,
        logoUrl,
        bannerUrl,
        primaryColor,
        description,
        updatedAt: new Date()
      });

      alert("✅ Store branding saved!");
    } catch (error) {
      console.error(error);
      alert("❌ Failed to save");
    }

    setSaving(false);
  };

  return (
    <div style={{ padding: "30px", background: "#fff", borderRadius: "12px", maxWidth: "700px" }}>

      <h2 className="text-2xl font-bold mb-6">Store Branding Panel</h2>

      <label>Store Code</label>
      <input
        value={storeCode}
        onChange={(e) => setStoreCode(e.target.value)}
        placeholder="ex: john123"
        className="border p-2 w-full mb-4"
      />

      <label>Store Name</label>
      <input
        value={storeName}
        onChange={(e) => setStoreName(e.target.value)}
        placeholder="John Fashion"
        className="border p-2 w-full mb-4"
      />

      <label>Logo URL</label>
      <input
        value={logoUrl}
        onChange={(e) => setLogoUrl(e.target.value)}
        placeholder="https://..."
        className="border p-2 w-full mb-4"
      />

      <label>Banner URL</label>
      <input
        value={bannerUrl}
        onChange={(e) => setBannerUrl(e.target.value)}
        placeholder="https://..."
        className="border p-2 w-full mb-4"
      />

      <label>Primary Color</label>
      <input
        type="color"
        value={primaryColor}
        onChange={(e) => setPrimaryColor(e.target.value)}
        className="mb-4 block"
      />

      <label>Description</label>
      <textarea
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="About this store..."
        className="border p-2 w-full mb-6 h-24"
      />

      <button
        onClick={handleSave}
        disabled={saving}
        className="bg-black text-white py-2 px-6 w-full rounded"
      >
        {saving ? "Saving..." : "SAVE STORE BRANDING"}
      </button>
    </div>
  );
}
